export default "__VITE_ASSET__vSKBfihT__"